<template>
<ol-map :loadTilesWhileAnimating="false" :loadTilesWhileInteracting="false" style="height:400px" v-if="renderComponent">

    <ol-view ref="view" :center="center" :rotation="rotation" :zoom="zoom" 
    :projection="projection" 
    @zoomChanged="zoomChanged"
    @centerChanged="centerChanged"
    />

    <ol-tile-layer>
        <ol-source-osm />
    </ol-tile-layer>

    <ol-vector-layer>
        <ol-source-vector :projection="projection">

            <ol-interaction-draw :type="drawType" @drawend="drawEnd" ref="draw">

            </ol-interaction-draw>

        </ol-source-vector>

        <ol-fullscreen-control />
        <!-- <ol-zoom-control /> -->
        <!-- <ol-zoomslider-control /> -->
        <ol-overviewmap-control >
            <ol-tile-layer>
                <ol-source-osm />
            </ol-tile-layer>
        </ol-overviewmap-control>

        <ol-style>
            <ol-style-stroke color="red" :width="2"></ol-style-stroke>
            <ol-style-fill color="rgba(255,255,255,0.1)"></ol-style-fill>
            <ol-style-circle :radius="7">
                <ol-style-fill color="blue"></ol-style-fill>
            </ol-style-circle>
        </ol-style>
    </ol-vector-layer>
    
</ol-map>

<br/>
<div class="field grid">
    <div class="col-4">
        <Button label="Hapus Lokasi" icon="pi pi-trash" @click="removePolygon()" class="col-md-4 p-button p-button-danger" />
    </div>
</div>

</template>

<script >
import Button from 'primevue/button';
import {debounce} from "debounce";
// import ref from "vue"
// <script>


import {
    ref,
    toRefs,
    toRef,
    computed
} from 'vue'


export default {
    emits: ['zoomChanged', 'centerChanged','update','update:modelValue'],
    props : {
        drawType : {
            type : String,
            default : 'Polygon',
        },
        center : {
            type : Array,
            default : [ 110.29204628725884, -7.271315649578181 ],
        },
        rotation : {
            type : Number,
            default : 0,
        },
        zoom : {
            type : Number,
            default : 8.307189523108057,
        },
        projection : {
            type : String,
            default : 'EPSG:4326',
        },
        modelValue : {
            type : Array,
            default : () => [],
        },
    },
    setup(props,{emit}) {
        // const {
        //     center,
        //     rotation,
        //     zoom,
        //     projection,
        // } = toRefs(props);

        // var center = ref(props.center);
        // var rotation = ref(props.rotation);
        // var zoom = ref(props.zoom);
        // var projection = ref(props.projection);
        // console.log(props.center);

        const center = toRef(props,'center');
        const rotation = toRef(props,'rotation');
        const zoom = toRef(props,'zoom');
        const projection = toRef(props,'projection');
        const modelValue = toRef(props,'modelValue');
        const drawType = toRef(props,'drawType');

        const renderComponent = ref(true);

        const draw = ref();

        const model = computed({
            get() {
                return props.modelValue;
            },
            set(value) {
                emit('update:modelValue', value);
            }
        });

        const drawEnd = (event) => {
            console.log(event);
            var geometry = event.feature.getGeometry();
            var coordinates = geometry.getCoordinates();
            var result = coordinates;
            // if result[0] is an array, take it to a single array
            if (result[0] instanceof Array) {
                result = [].concat.apply([], result);
            }
            // this.modelValue = coordinates;
            emit('update:modelValue', result);
            // this.$emit('update:modelValue', this.modelValue);
        }

        // const zoomChanged = () => {
        //     console.log('zoomed');
        //     // alert('zoomChanged');
        // }

        return {
            center,
            rotation,
            zoom,
            projection,
            model,
            modelValue,
            drawEnd,
            draw,
            drawType,
            renderComponent,
            // zoomChanged,
            // Button
        }
    },
    data() {
        return {
            current_center : this.center,
            current_zoom : this.zoom,
            current_draw : this.draw
        }
    },
    components: {
        Button
    },
    methods : {
        zoomChanged(current_zoom) {
            this.current_zoom = current_zoom;
            // this.current_center = this.center;
            // this.zoom = current_zoom;
            // alert('zoom changed');
            // this.current_zoom = current_zoom;
            // var result = this.modelValue;
            // result.current_zoom = current_zoom;
            this.$emit('zoomChanged', current_zoom);
            // console.log('current_zoom',current_zoom);


            // this.current_zoom = event.target.getZoom();
            // this.$emit('zoomChanged', this.current_zoom);
        },
        centerChanged(current_center) {
            this.current_center = current_center;
            // var result = this.modelValue;
            // result.current_zoom = current_zoom;
            // emit('update:modelValue', result);
            // console.log('current_center',current_center);


            // this.current_center = event.target.getCenter();
            this.$emit('centerChanged', this.current_center);
        },
        removePolygon() {
            // this.current_draw.remove();
            this.$emit('update:modelValue', []);
            this.forceRerender();
        },
        forceRerender(){
            console.log('render b4');
            this.renderComponent = false;
            
            this.$nextTick(() => {
            // Adding the component back in
                this.renderComponent = true;
            });
        }
    },
    created () {
        this.zoomChanged = debounce(this.zoomChanged,300);
        this.centerChanged = debounce(this.centerChanged,300);
    }
}
</script>

<style>

</style>